export default __webpack_public_path__ + "static/media/ic_back_btn.89ab0aec.svg";